import { render, staticRenderFns } from "./ModalInsercaoResultado.vue?vue&type=template&id=57dd6c28&lang=pug"
import script from "./ModalInsercaoResultado.vue?vue&type=script&lang=js"
export * from "./ModalInsercaoResultado.vue?vue&type=script&lang=js"
import style0 from "./ModalInsercaoResultado.vue?vue&type=style&index=0&id=57dd6c28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports